import React from "react"
const TradeArrow = ({ className }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 812 1314"
    preserveAspectRatio="xMidYMid slice"
    className={className}
  >
    <g>
      <polygon points="9.9942684,1304 9.9942684,928.9588623 296.0127258,732.6237793 802.0057373,732.6237793" />
      <polygon points="9.9942684,10 9.9942684,385.0411682 296.0127258,581.3762207 802.0057373,581.3762207" />
    </g>
  </svg>
)

export default TradeArrow